import { FolderOpenRounded } from "@material-ui/icons";
const currentDate = new Date();
const currentDateString = currentDate.toISOString().split('T')[0];
const currentDateWithTimeString = `${currentDateString}-hr-03-00-00`;
export const layer = [

  {
    id: 1,
    text: "States",
    show: false,
    class: "Administrative",
    layer: "ncmrwf:state",
    link: "https://api.ncmrwf.gov.in/geoserver/ncmrwf/wms",
    opacity:"",
    date:"",
    altitude:"",
    dataset:"",
    datatype:"",
    modelname:"",
    modeltype:"",
    noofdays:"",
    legend:""
  },
  {
    id: 2,
    text: "India",
    show: true,
    class: "Administrative",
    layer: "nncmrwf:india_boundary",
    link: "https://api.ncmrwf.gov.in/geoserver/ncmrwf/wms",
    opacity:"",
    date:"",
    altitude:"",
    dataset:"",
    datatype:"",
    modelname:"",
    modeltype:"",
    noofdays:"",
    legend:""
  },
  {
    id: 3,
    text: "Global",
    show: true,
    class: "Administrative",
    layer: "ncmrwf:global_boundaries",
    link: "https://api.ncmrwf.gov.in/geoserver/ncmrwf/wms",
    opacity:"",
    date:"",
    altitude:"",
    dataset:"",
    datatype:"",
    modelname:"",
    modeltype:"",
    noofdays:"",
    legend:""
  },
  {
    id: 4,
    text: "Mithuna GLB",
    show: true,
    class: "Model",
    layer: "dhurbi:road",
    link: "https://api.ncmrwf.gov.in/",
    opacity:75,
    odate:currentDateString,
    date:currentDateWithTimeString,
    altitude:850,
    dataset:"global",
    datatype:"temperature",
    modelname:"",
    modeltype:"",
    hours:0,
    showGeopotentialHeights:false,
    showWindVectors:true,
    noofdays:7,
    variables:{variables:["Temperature", "Humidity", "Rainfall", "Accumulated Rainfall"]},
    legend:{
      temperature:{
        925:{
          colorBar:["#AF00AF", "#DC00DC", "#3232C8", 
                    "#0064FF", "#009696", "#00C832", "#64FF00", 
                    "#96FF00", "#C8FF32", "#FFFF00", "#FFC800", 
                    "#FFA000", "#FF7D00", "#E11900", "#C80000", 
                    "#BD0000", "#810000", "#000000"], //"#640064"
          range:[0,0,-10, -5, 0, 3, 6, 9, 12, 15, 18, 20, 22, 24, 26, 28, 30, 32, 34],
        },
        500:{
          colorBar:[ "#AF00AF", "#DC00DC", "#3232C8", 
                    "#0064FF", "#009696", "#00C832", "#64FF00", 
                    "#96FF00", "#C8FF32", "#FFFF00", "#FFC800", 
                    "#FFA000", "#FF7D00", "#E11900", "#C80000", 
                    "#BD0000", "#810000", "#000000"], //"#640064"
          range:[0,0, -35, -30, -28, -26, -24, -22, -20, -18, -16, -14, -12, -10, -8, -6, -4, -2, 0],
        },
        700:{
          colorBar:["#AF00AF", "#DC00DC", "#3232C8", 
                    "#0064FF", "#009696", "#00C832", "#64FF00", 
                    "#96FF00", "#C8FF32", "#FFFF00", "#FFC800", 
                    "#FFA000", "#FF7D00", "#E11900", "#C80000", 
                    "#BD0000", "#810000", "#000000"], //"#640064"
          range:[0,0,-20, -16, -12, -8, -4, 0, 2, 4, 6, 8, 9, 10, 11, 12, 13, 14, 15],
        },
        850:{
          colorBar:[ "#AF00AF", "#DC00DC", "#3232C8", 
                    "#0064FF", "#009696", "#00C832", "#64FF00", 
                    "#96FF00", "#C8FF32", "#FFFF00", "#FFC800", 
                    "#FFA000", "#FF7D00", "#E11900", "#C80000", 
                    "#BD0000", "#810000", "#000000"], //"#640064"
          range:[0,0,-15, -10, -5, 0, 3, 6, 9, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30],
        },
        200:{
          colorBar:[ "#AF00AF", "#DC00DC", "#3232C8", 
                      "#0064FF", "#009696", "#00C832", "#64FF00", 
                      "#96FF00", "#C8FF32", "#FFFF00", "#FFC800", 
                      "#FFA000", "#FF7D00", "#E11900", "#C80000", 
                      "#BD0000", "#810000", "#000000"], //"#640064"
          range:[0,0, -70, -65, -60, -58, -57, -56, -55, -54, -53, -52, -50, -48, -46, -44, -42, -40, -20],
        },
        units:'°C'
      },
      humidity:{
        colorBar:[  '#8b4513', '#9b4d15', '#ac5518', '#bd5e1a', '#cd661d', 
                    '#db7518', '#ea8a0d', '#f59806', '#fa9f02', '#f5a603',  
                    '#c3b012', '#92b921', '#61c230', '#2dcb42', '#2abd6f',  
                    '#28b685', '#24a8b2', '#2099df', '#218cfc', '#1625a9'],
        range:[0, 5, 10,15,20,25,30,35,40,45,50,55,60,65,70,75,80,85,90,95,100],
        units:'%'
      },
      rainfall:{
        colorBar:["#FFFFFF","#87CEFA","#1E90FF","#0000FF","#008000","#FFFF00","#FFA500","#FF0000","#800080" ],
        range:[0,0, 0.1, 1, 2, 4, 8, 16, 32, 64],
        units:'mm'
      },
      acurain:{
        colorBar:["#FFFFFF","#87CEFA","#1E90FF","#0000FF","#008000","#FFFF00","#FFA500","#FF0000","#800080" ],
        range:[0,0, 0.1, 1, 2, 4, 8, 16, 32, 64],
        units:'cm'
      },
      wind:{
        925:{
          colorBar:[ "#FFFFFF", "#B5CAFF", "#8FB3FF", "#7F97FF",
                    "#ABCF63", "#E8F59E", "#FFFA14", "#FFD121",
                    "#FFA30A", "#FF4C00"],
          range:[0,0,1, 2, 4, 6, 8, 10, 12, 14, 16],
        },
        500:{
          colorBar:[ "#FFFFFF", "#B5CAFF", "#8FB3FF", "#7F97FF",
                    "#ABCF63", "#E8F59E", "#FFFA14", "#FFD121",
                    "#FFA30A", "#FF4C00"],
          range:[0,0, 3, 6, 9, 12, 15, 18, 20, 25, 30],
        },
        700:{
          colorBar:[ "#FFFFFF", "#B5CAFF", "#8FB3FF", "#7F97FF",
                    "#ABCF63", "#E8F59E", "#FFFA14", "#FFD121",
                    "#FFA30A", "#FF4C00"],
          range:[0,0,3, 6, 9, 12, 15, 18, 21, 24, 27],
        },
        850:{
          colorBar:[ "#FFFFFF", "#B5CAFF", "#8FB3FF", "#7F97FF",
                    "#ABCF63", "#E8F59E", "#FFFA14", "#FFD121",
                    "#FFA30A", "#FF4C00"],
          range:[0,0,2, 4, 6, 8, 10, 12, 14, 16, 18],
        },
        200:{
          colorBar:[ "#FFFFFF", "#B5CAFF", "#8FB3FF", "#7F97FF",
                    "#ABCF63", "#E8F59E", "#FFFA14", "#FFD121",
                    "#FFA30A", "#FF4C00"],
          range:[0,0,10, 20, 30, 40, 50, 60, 70, 80, 90],
        },
        units:'m/s'
      }
    }
  },  
  // {
  //   id: 5,
  //   text: "Regional Model",
  //   show: false,
  //   class: "Model",
  //   layer: "dhurbi:road",
  //   link: "https://api.ncmrwf.gov.in/",
  //   opacity:75,
  //   odate:"2025-02-06",
  //   date:"2025-02-06",
  //   altitude:850,
  //   dataset:"regional",
  //   datatype:"Temperature",
  //   modelname:"",
  //   modeltype:"",
  //   hours:0,
  //   noofdays:3,
  //   legend:{
  //     Temperature:{
  //       colorBar:[
  //         '#4b0082', '#580594', '#660ba7', '#7417bf', '#8325d7', '#6e45e9', 
  //         '#406ff5', '#1996ff', '#0bacff', '#02bff3', '#17c59c', '#2bcb4b', 
  //         '#81d026', '#e1d509', '#ffbf00', '#ff9c00', '#ff7d00', '#ff5d00', 
  //         '#f13c00', '#bc1d00', '#8b0000'
  //       ],
  //       range:[-20, 1, 41],
  //       units:'°C'
  //     },
  //     Humidity:{
  //       colorBar:[
  //         '#934914', '#ac5518', '#c5621c', '#db7518', '#ea8a0d', '#f79f04', 
  //         '#c3b012', '#7abd28', '#36c746', '#29ba7a', '#25aca7', '#219cd4', 
  //         '#208ff9', '#2785f6', '#2f7cf0', '#3872e8', '#3e67df', '#3150cc', 
  //         '#2237b8', '#121ea4', '#040690'
  //       ],
  //       range:[0, 5, 102],
  //       units:'%'
  //     },
  //     Rainfall:{
  //       colorBar:[
  //         '#9cceff', '#6eb8ff', '#40a1ff', '#1f94f0', '#24a8b0', '#2abc70', 
  //         '#3ecc3a', '#86d024', '#ccd410', '#fed000', '#ffbe00', '#ffb000', 
  //         '#ffa500', '#ff9700', '#ff8c00', '#ff732d', '#ff5d55', '#ff4482', 
  //         '#ff2eaa', '#ff15d7', '#ff00ff'
  //       ],
  //       range:[0, 2, 102],
  //       units:'mm'
  //     },
  //     Wind:{
  //       colorBar:[
  //         '#440154', '#46085c', '#471063', '#481769', '#481d6f', '#482475',
  //         '#472a7a', '#46307e', '#453781', '#433e85', '#414487', '#3e4989', 
  //         '#3c4f8a', '#3a548c', '#375a8c', '#355f8d', '#32648e', '#306a8e',
  //         '#2e6f8e', '#2c738e', '#2a788e', '#287d8e', '#26828e', '#24868e',
  //         '#228b8d', '#21918c', '#1f958b', '#1f9a8a', '#1f9f88', '#20a386',
  //         '#22a884', '#26ad81', '#2cb17e', '#32b67a', '#3bbb75', '#44bf70',
  //         '#4ec36b', '#58c765', '#63cb5f', '#6ece58', '#7ad151', '#86d549', 
  //         '#95d840', '#a2da37', '#b0dd2f', '#bddf26', '#cae11f', '#d8e219', 
  //         '#e5e419', '#f1e51d', '#fde725'
  //       ],
  //       range:[0, 2, 102],
  //       units:'m/s'
  //     }
  //   }
  // },  
  {
    id: 5,
    text: "WBGT",
    show: false,
    class: "Model",
    layer: "dhurbi:road",
    link: "https://api.ncmrwf.gov.in/",
    opacity:75,
    odate:currentDateString,
    date:currentDateWithTimeString,
    altitude:850,
    dataset:"global",
    datatype:"wbgt",
    modelname:"",
    modeltype:"",
    hours:0,
    showGeopotentialHeights:false,
    showWindVectors:true,
    noofdays:7,
    variables:{variables:["WBGT"]},
    legend:{
            wbgt:{
          colorBar: [
               "#e6e3e36e", // 23-25°C: Light Cyan (Start)
              "#E0FFFF", // 23-25°C: Light Cyan (Start)
              "#32CD32", // 25-27°C: Lime Green (Caution)
              "#FFFF00", // 27-29°C: Yellow (Warning)
              "#FFA500", // 29-31°C: Orange (Severe)
              "#FF0000", // 31-33°C: Red (Danger)
              "#000000", // 33-35°C: Dark Red (Extreme)
              // "#000000"  // 35-40°C: Black (Critical)
          ],
          range: [0,0,23, 25, 27, 29, 31, 33, 35],
          units: '°C'
      }
    }
  },
];

export const maps = [
	// {
	// 	"id": 1,
	// 	"text": "Google Map",
	// 	"show": false,
	// 	"class": "Maps",
	// 	"layer": "analytic:ner_boundary",
	// 	"link": "https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
	// 	"format": "image/png",
	// 	"type": "tile",
	// 	"image": "google.png",
	// 	"description": "Google Maps is a web mapping platform and consumer application offered by Google. It offers satellite imagery, aerial photography, street maps, 360° interactive panoramic views of streets, real-time traffic conditions, and route planning for traveling."
	// },
	// {
	// 	"id": 2,
	// 	"text": "Mapbox Light",
	// 	"show": false,
	// 	"class": "Maps",
	// 	"layer": "analytic:ner_boundary",
	// 	"link": "https://api.mapbox.com/styles/v1/mapbox/light-v10/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZGluZXNoa2N1YmUiLCJhIjoiY2p2Z2Jzc3pyMDVwajN5bWowdjA1YTAyMSJ9.TcJaEwi-qTQqBPqTh0Kt2g",
	// 	"format": "image/png",
	// 	"domain": " ",
	// 	"type": "tile",
	// 	"image": "stamen.png",
	// 	"description": "Mapbox Light and Mapbox Dark are subtle, full-featured maps designed to provide geographic context while highlighting the data on your analytics dashboard, data visualization, or data overlay."
	// },
	{
		"id": 1,
		"text": "Satellite",
		"show": true,
		"class": "Maps",
		"layer": "analytic:ner_boundary",
		"link": "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
		"format": "image/png",
		"image": "satellite.png",
		"description": "Satellite images are images of Earth collected by imaging satellites operated by governments and businesses around the world. Satellite imaging companies sell images by licensing them to governments and businesses such as Apple Maps and Google Maps."
	}
  //,
	// {
	// 	"id": 4,
	// 	"text": "Terrain Map",
	// 	"show": false,
	// 	"class": "Maps",
	// 	"layer": "ace2dem",
	// 	"link": "https://mt1.google.com/vt/lyrs=p&x={x}&y={y}&z={z}",
	// 	"format": "image/png",
	// 	"type": "tile",
	// 	"image": "terrain.png",
	// 	"description": "In modern mapping, a topographic map or topographic sheet is a type of map characterized by large-scale detail and quantitative representation of relief features, usually using contour lines, but historically using a variety of methods."
	// }
	// {
	// 	"id": 5,
	// 	"text": "Stamen Map",
	// 	"show": false,
	// 	"class": "Maps",
	// 	"layer": "terrain-background",
	// 	"link": "https://stamen-tiles-{s}.a.ssl.fastly.net/terrain-background/{z}/{x}/{y}.png",
	// 	"format": "image/png",
	// 	"type": "tile",
	// 	"image": "stamen.png",
	// 	"description": "In modern mapping, a topographic map or topographic sheet is a type of map characterized by large-scale detail and quantitative representation of relief features, usually using contour lines, but historically using a variety of methods."
	// }
];

export const apps = [
  {
    id: 1,
    app: "GeoPortal",
    show: true,
  },
  {
    id: 2,
    app: "Flood",
    show: false,
  },
  {
    id: 3,
    app: "Agriculture",
    show: false,
  },
  {
    id: 4,
    app: "Atmospheric Sciences",
    show: false,
  },
  {
    id: 5,
    app: "Geosciences",
    show: false,
  },
];

export const panelVisibilty = [
  {
    id: "Alert",
    text: "Alert",
    show: false,
    panel: false,
  },
  {
    id: "Layer",
    text: "Layer",
    show: true,
    panel: true,
  },
  {
    id: "Legend",
    show: false,
    panel: false,
  },
  {
    id: "Stats",
    show: false,
    panel: false,
  },
  {
    id: "Tools",
    show: false,
    panel: false,
  },
  {
    id: "Apps",
    show: false,
    panel: false,
  },
  {
    id: "Search",
    show: false,
    panel: false,
  },
  {
    id: "Admin",
    show: false,
    panel: false,
  },
];

